import vaultComponents from "../../../../web-sh/src/pages/admin/vault/components";

import FormData from "./FormData";

vaultComponents.FormData = FormData;

export default vaultComponents;